// src/components/ActiveUsers.jsx
import React, { useState, useEffect } from 'react'
import './ActiveUsers.css'
import { getEnv } from '../config/env'

const ActiveUsers = () => {
  const [users, setUsers] = useState([])
  const [searchTerm, setSearchTerm] = useState('')
  const [sessionId, setSessionId] = useState('')
  const [conversation, setConversation] = useState([])
  const [showConversation, setShowConversation] = useState(false)

  useEffect(() => {
    fetchActiveUsers()
  }, [])

  const fetchActiveUsers = async () => {
    try {
      const apiBase = getEnv('REACT_APP_AI_INSIGHTS_BASE_URL')
      const resp = await window.PDR.api.get(`${apiBase}/get_active_users`)
      setUsers(resp)
    } catch (err) {
      console.error('Fetch active users error:', err)
    }
  }

  const fetchConversation = async (sid) => {
    try {
      const apiBase = getEnv('REACT_APP_AI_INSIGHTS_BASE_URL')
      const resp = await window.PDR.api.post(`${apiBase}/conversation_history`, { session_id: sid })
      setConversation(resp)
      setShowConversation(true)
    } catch (err) {
      console.error('Fetch conversation error:', err)
      setConversation([])
      setShowConversation(true)
    }
  }

  const handleSearchChange = (e) => setSearchTerm(e.target.value)
  const handleSessionChange = (e) => setSessionId(e.target.value)
  const handleRunClick = () => fetchConversation(sessionId)

  const getLastActivity = (sessions) => {
    if (!sessions || !Object.values(sessions).length) return ''
    const latest = Object.values(sessions).reduce((p, c) => (new Date(c.timestamp) > new Date(p.timestamp) ? c : p))
    return new Date(latest.timestamp).toLocaleString()
  }

  return (
    <div className="active-users-page">
      <div className={`active-users-container ${showConversation ? 'shift-left' : ''}`}>
        <h1>Active Users</h1>

        <div className="session-input-bar">
          <input type="text" placeholder="Enter session ID..." value={sessionId} onChange={handleSessionChange} />
          <button onClick={handleRunClick}>Load Conversation</button>
        </div>

        <div className="filter-bar">
          <input type="text" placeholder="Search by User ID..." value={searchTerm} onChange={handleSearchChange} />
        </div>

        <div className="users-list">
          {users
            .filter((u) => u.userId.toLowerCase().includes(searchTerm.toLowerCase()))
            .map((user) => (
              <div key={user.userId} className="user-card">
                <div className="user-header">
                  <div>
                    <strong>User ID:</strong> {user.userId}
                  </div>
                  <div>
                    <strong>Tenant ID:</strong> {user.tenant_id}
                  </div>
                  <div>
                    <strong>Prev Sessions:</strong>{' '}
                    {user.prev_session && user.prev_session.length > 0
                      ? user.prev_session.map((pid) => (
                          <button key={pid} className="session-id-btn" onClick={() => fetchConversation(pid)}>
                            {pid}
                          </button>
                        ))
                      : 'None'}
                  </div>
                  <div>
                    <strong>Staged Sessions:</strong>{' '}
                    {user.staged_sessions && user.staged_sessions.length > 0
                      ? user.staged_sessions.map((sid) => (
                          <button key={sid} className="session-id-btn" onClick={() => fetchConversation(sid)}>
                            {sid}
                          </button>
                        ))
                      : 'None'}
                  </div>
                  <div>
                    <strong>Last Activity:</strong> {getLastActivity(user.sessions)}
                  </div>
                </div>

                <details className="sessions-details">
                  <summary>Sessions ({Object.keys(user.sessions || {}).length})</summary>
                  <div className="sessions-list">
                    {Object.entries(user.sessions || {}).map(([name, sess]) => (
                      <div key={sess.session_id} className="session-item">
                        <div className="session-name">
                          <strong>{name}</strong>
                        </div>
                        <button
                          className="session-id-btn"
                          onClick={() => {
                            setSessionId(sess.session_id)
                            fetchConversation(sess.session_id)
                          }}>
                          {sess.session_id}
                        </button>
                        <pre>{JSON.stringify(sess, null, 2)}</pre>
                      </div>
                    ))}
                  </div>
                </details>
              </div>
            ))}
        </div>
      </div>

      {showConversation && (
        <div className="conversation-card">
          <div className="conversation-header">
            <h2>Conversation History</h2>
            <button className="close-btn" onClick={() => setShowConversation(false)}>
              ×
            </button>
          </div>
          <div className="chat-window">
            {conversation.map((msg, idx) => (
              <div key={idx} className={`message-bubble message-${msg.type}`}>
                <div className="msg-content">{msg.message}</div>
                <div className="msg-timestamp">{new Date(msg.timestamp).toLocaleString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default ActiveUsers
